<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Ubicación Almacenamiento</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Ubicación Almacenamiento</h6>
    </table>
    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="form">
        <div class="container-fluid">
            <div class="row align-items-center">

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdCompania}}</mat-label>
                        <mat-select [compareWith]="compareCompanias" formControlName="idCompania">
                            <mat-option [value]="-1">- Seleccione -</mat-option>
                            <mat-option *ngFor="let c of companias" [value]="c.id">{{c.descripcion}}
                            </mat-option>
                        </mat-select>

                        <mat-error
                            *ngIf="(form.get('idCompania').hasError('required')) && form.get('idCompania').touched ">
                            {{Validaciones.Compania}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdSalesOrg}}</mat-label>
                        <mat-select [compareWith]="compareSalesOrgs" formControlName="idSalesOrg">
                            <mat-option [value]="-1">- Seleccione -</mat-option>
                            <mat-option *ngFor="let s of salesOrgs" [value]="s.id">{{s.descripcion}}
                            </mat-option>
                        </mat-select>

                        <mat-error
                            *ngIf="(form.get('idSalesOrg').hasError('required')) && form.get('idSalesOrg').touched ">
                            {{Validaciones.SalesOrg}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdPlanta}}</mat-label>
                        <mat-select (selectionChange)="selectPlantas($event.value)" [compareWith]="comparePlantas"
                            formControlName="idPlanta">
                            <mat-option [value]="-1">- Seleccione -</mat-option>
                            <mat-option *ngFor="let p of plantas" [value]="p.idPlanta">{{p.displayValue}}
                            </mat-option>
                        </mat-select>

                        <mat-error *ngIf="(form.get('idPlanta').hasError('required')) && form.get('idPlanta').touched ">
                            {{Validaciones.IdPlanta}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Codigo}}</mat-label>
                        <input type="text" matInput formControlName="id">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                            (click)="clearInput('id')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>

                        <mat-error *ngIf="(form.get('id').hasError('required')) && form.get('id').touched ">
                            {{Validaciones.Codigo}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Descripcion}}</mat-label>
                        <input type="text" matInput formControlName="descripcion">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                            (click)="clearInput('descripcion')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>

                        <mat-error
                            *ngIf="(form.get('descripcion').hasError('required')) && form.get('descripcion').touched ">
                            {{Validaciones.Descripcion}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Cuenta}}</mat-label>
                        <input (change)="handleEmptyInputCuenta($event)" matInput [matAutocomplete]="autoC"
                            [formControl]="fcAutocompleteCuenta" placeholder="Nro. cliente, nombre, etc...">
                        <button type="button" matSuffix mat-icon-button matTooltip="Limpiar cuenta seleccionada"
                            (click)="limpiarCuenta(true)">

                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>

                        <mat-autocomplete #autoC="matAutocomplete"
                            (optionSelected)='seleccionarCuenta($event.option.value)'
                            [displayWith]="getOptionTextCuenta">
                            <mat-option *ngIf="loadingFcAutocompleteCuenta" class="is-loading">Cargando...</mat-option>
                            <ng-container *ngIf="!loadingFcAutocompleteCuenta">
                                <mat-option *ngFor="let c of cuentasEncontradas" [value]="c">
                                    {{c.displayValue}}
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>

                    </mat-form-field>
                </div>
               
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.NroClienteDireccionEntrega}}</mat-label>

                            <input readonly formControlName="nroClienteDireccionEntrega" type="text" matInput>
                            <mat-error
                                *ngIf="(form.get('nroClienteDireccionEntrega').hasError('required')) && form.get('nroClienteDireccionEntrega').touched">
                                {{Validaciones.NroClienteDireccionEntrega}}
                            </mat-error>

                        </mat-form-field>
                    </div>                   
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.NombreClienteDireccionEntrega}}</mat-label>

                            <input readonly formControlName="nombreClienteDireccionEntrega" type="text" matInput>
                            <mat-error
                                *ngIf="(form.get('nombreClienteDireccionEntrega').hasError('required')) && form.get('nombreClienteDireccionEntrega').touched">
                                {{Validaciones.NombreClienteDireccionEntrega}}
                            </mat-error>
                        </mat-form-field>
                    </div>
          

                <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <mat-checkbox class="cell" formControlName="habilitacion" color="primary-darker">
                        {{Etiquetas.Habilitacion}}
                    </mat-checkbox>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                    <mat-checkbox class="cell" formControlName="expoTransferencias" color="primary-darker">
                        {{Etiquetas.ExpoTransferencias}}
                    </mat-checkbox>
                </div>
            </div>
        </div>

    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button *ngIf="!isInRole('CONSULTOR')" (click)="guardarUbicacionAlmacenamiento()" [disabled]="form.invalid"
        mat-flat-button color="accent">Guardar</button>
    <button mat-dialog-close *ngIf="isInRole('CONSULTOR')" mat-flat-button color="accent">Salir</button>

</mat-dialog-actions>